// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2G8ki","title":"BackImages_title__td9Ry","images":"BackImages_images__1deYE"};